/**
 * Styled Components - Created by cazarez on 11/04/18.
 */
import styled from 'styled-components'
import Button from 'antd/lib/button'
import {
  WHITE,
  GRAY_DARK,
  GRAY_STRONG,
  GRAY,
  GRAY_LIGHT,
  RED,
  RED_TRANSPARENT,
  BLACK_LIGHT,
  GREEN_LIGHT,
  GRAY_LIGHTEST,
  BLUE
} from '../../theme/colors'
import { BLACK } from '../../screens/DesignerTool/constants'
import Icon from 'antd/lib/icon'
import Popover from 'antd/lib/popover'

interface DivProps {
  small?: boolean
}

interface CellProps {
  color?: string
  textAlign?: string
  small?: boolean
  positive?: boolean
}

export const Container = styled.tr`
  transition: all .25s;
  background: ${WHITE};
  &:hover {
    cursor: pointer;
    background: whitesmoke;
  }
`

export const Cell = styled.td`
  border-bottom: 1px solid ${GRAY_LIGHT};
  text-align: left;
  padding: ${({ positive }: CellProps) => positive ? '8px' : '8px 0'};
  color: ${({ color }: CellProps) => (color ? color : GRAY_DARK)};
  background-color: ${({ positive }: CellProps) => (positive ? GREEN_LIGHT : '')};
  background-clip: content-box;
  font-size: 14px;
  letter-spacing: 0.1px;
  height: 50px;
  text-align: ${({ textAlign }: CellProps) =>
    textAlign ? textAlign : 'start'};
  position: relative;
  &.error {
    color: ${RED};
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    font-size: 10px;
  }

  @media (min-width: 331px) and (max-width: 768px) {
    letter-spacing: 0.09px;
    font-size: 12px;
  }

  @media (max-width: 330px) and (max-width: 768px) {
    letter-spacing: 0.09px;
    font-size: 11px;
  }
`

export const BannerCell = styled.img`
  max-width: 158px;
  border-radius: 3px;
`

export const Text = styled.div`
  color: ${WHITE};
`

export const StyledImg = styled.img`
  width: 100%;
  height: 100%;
  max-height: 143px;
  object-fit: cover;
`

export const TitleName = styled.div`
  height: 74px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: ${GRAY};
  color: ${GRAY_STRONG};
  font-size: 20px;
  font-weight: bold;
`

export const TitleNameDesktop = styled.div`
  max-width: 158px;
  min-height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: ${GRAY};
  color: ${GRAY_STRONG};
  font-size: 10px;
  font-weight: bold;
  border-radius: 3px;
  white-space: pre-wrap;
  text-align: center;
`

export const TitleNamePop = styled.div`
  width: 448px;
  min-height: 84px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: ${GRAY};
  color: ${GRAY_STRONG};
  font-size: 14px;
  font-weight: bold;
  border-radius: 3px;
  white-space: pre-wrap;
  text-align: center;
`

export const TeamStoreCard = styled.div`
  width: ${({ small }: DivProps) => (small ? '428px' : '658px')};
  position: relative;
  @media (max-width: 1648px) {
    width: ${({ small }: DivProps) => (small ? '390px' : '600px')};
  }
  @media (max-width: 1375px) {
    width: ${({ small }: DivProps) => (small ? '355px' : '545px')};
  }
  @media (max-width: 1224px) {
    width: ${({ small }: DivProps) => (small ? '280px' : '430px')};
  }
  @media (max-width: 1024px) {
    width: ${({ small }: DivProps) => (small ? '270px' : '415px')};
  }

  @media (min-width: 370px) and (max-width: 767px) {
    width: 100%;
  }
`

export const ImportedLabel = styled.div`
  font-size: 12px;
  position: absolute;
  left: 46px;
  top: -12px;
  z-index: 2;
  background: white;
  border-radius: 25px;
  padding: 4px 10px;
  padding-left: 10px;
  box-shadow: 1px 2px 3px -1px #999999;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #f1f1f1;
`

export const ImportedLabelRow = styled.div`
  font-size: 10px;
  position: absolute;
  white-space: nowrap;
  left: -10px;
  bottom: 0px;
  z-index: 2;
  background: #ffffffd1;
  border-radius: 25px;
  padding: 2px 8px;
  padding-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #f0f0f0;
`

export const ImportedIcon = styled(Icon)`
  transform: rotate(-90deg);
  color: #7c61b4;
  margin-right: 6px;
`

interface CardProps {
  closedMessage?: string
}

export const CardContent = styled.div`
  background-color: ${WHITE};
  box-shadow: 0 2px 4px 0 ${GRAY_LIGHT};
  position: relative;
  &: before {
    background: ${({ closedMessage }: CardProps) =>
    closedMessage ? RED_TRANSPARENT : 'none'};
    color: ${BLACK};
    top: 8px;
    padding: 5px;
    position: absolute;
    text-align: center;
    content: ${({ closedMessage }: CardProps) => `'${closedMessage}'`};
    width: 100%;
  }
`

export const CardTitle = styled.div`
  cursor: text;
  text-shadow: 0px 2px 4px ${GRAY_DARK};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StoreType = styled.div`
  cursor: text;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  text-align: center;
  background: ${BLACK_LIGHT};
  border: 1px solid ${WHITE};
  color: ${WHITE};
  font-weight: 500;
  height: 24px;
  padding: 0 12px;
  @media (max-width: 480px) {
    line-height: 20px;
    min-width: 45%;
    border-color: ${GRAY};
  }
`

export const BottomContainer = styled.div`
  color: ${WHITE};
  font-size: 18px;
  width: 100%;
  font-weight: 600;
  letter-spacing: 0.23px;
  line-height: 25px;
  position: absolute;
  bottom: 0px;
  background: linear-gradient(0deg, #54545494, #54545400);
  padding: 4px 8px;
  display: flex;
  justify-content: flex-end;
`

export const ShareButton = styled(Button)`
  height: 24px;
  border: 1px solid ${GRAY_LIGHT};
  border-radius: 2px;
  background-color: ${WHITE};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.07);
  margin-left: 10px;

  span {
    color: ${GRAY_DARK};
    font-size: 14px;
    letter-spacing: 0.1px;
    line-height: 19px;
    text-align: center;
  }

  @media (max-width: 480px) {
    margin-left: 0;
    width: 35%;
  }
`

export const EditButton = ShareButton.extend``

export const EditButtonMobile = ShareButton.extend`
  position: absolute;
  right: 3px;
  top: 2px;
  max-width: 60px;
`

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  @media (max-width: 480px) {
    width: 100%;
    justify-content: space-between;
    margin-top: 20px;
  }
`
export const DeleteLabel = styled.span`
  display: flex;
  align-items: center;
  color: ${WHITE};
  font-size: 14px;
  font-weight: normal;
  background: ${RED};
  justify-content: center;
  box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.18);
  border-radius: 2px;
  margin-left: 10px;
  padding: 0 12px;
  @media (max-width: 480px) {
    margin-left: 0;
    width: 76px;
  }
`

export const CodeLabel = styled.div`
  position: absolute;
  right: 0;
  z-index: 2;
  display: flex;
  background: #ffffffe6;
  padding: 2px 12px;
  font-family: Avenir;
  border-radius: 25px;
  bottom: -5px;
  box-shadow: 1px 2px 3px -1px #9f9f9f;
  border-top: 1px solid #f1f1f1;
  font-size: 12px;
`

export const CodeIcon = styled(Icon)`
  margin-right: 6px;
  margin-left: -2px;
  color: #bf9952;
`

export const CodeText = styled.div`
  margin-right: 4px;
  font-weight: 500;
`

export const MobileContainer = styled.div`
  display: flex;
  flex-flow: column;
  box-shadow: 1px 2px 6px -1px #bebebe;
  border-top: 1px solid #e3e3e3;
  margin-bottom: 20px;
  border-radius: 3px;
  margin-left: 6px;
  margin-right: 6px;
  position: relative;
`

export const BannerMobile = styled.img`
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
  max-width: 100%;
  max-height: 84px;
  object-fit: cover;
`

export const BottomDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 10px 12px;
  padding-bottom: 0;
  column-gap: 30px;
`

export const LabelDiv = styled.div`
  margin-bottom: 10px;
`

export const TitleLabel = styled.div`
  font-weight: 500;
  font-family: Avenir;
`

export const LabelValue = styled.div`
  font-family: Avenir;
`

export const StorePopover = styled(Popover)`
  .ant-popover-inner-content {
    padding: 4px 6px;
  }
  .ant-popover-arrow {
    display: none;
  }
`

export const BannerThumbnail = styled.img`
  object-fit: contain;
  max-height: 180px;
  max-width: 448px;
  background: ${GRAY_LIGHTEST};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const BannerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
`

export const ClosedMessage = styled.div`
  font-size: 10.5px;
  width: 418px;
  background: #ff000036;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  text-align: center;
  padding: 4px;
`

export const DownloadCSVIcon = styled(Icon)`
  margin-left: 8px;
  color: ${BLUE};
  transition: all .25s;
  &:hover {
    background: ${BLUE};
    color: ${WHITE};
    border-radius: 25px;
    padding: 4px;
  }
`

export const QrCodeIcon = styled.img`
  max-width: 20px;
  box-shadow: 0px 1px 2px 0px gray;
  padding: 2px;
  border-radius: 3px;
  margin-right: 10px;
  filter: grayscale(0.5);
  transition: all .25s;
  &:hover {
    cursor: pointer;
    transform: scale(1.1);
    background: #cbdeff;
  }
`

export const QrCodeIconMobile = styled.img`
  max-width: 24px;
  box-shadow: 0px 1px 2px 0px gray;
  padding: 2px;
  margin-right: 10px;
  filter: grayscale(0.5);
  position: absolute;
  left: 4px;
  top: 3px;
  background: ${WHITE};
  border-radius: 5px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    transform: scale(1.1);
    background: #cbdeff;
  }
`

export const StyledTooltip = styled(Popover)``

export const TooltipContent = styled.div`
  max-width: 388px;
`

export const BulkShipIcon = styled.img`
  max-width: 20px;
`

export const BulkShipIconMobile = styled.img`
  max-width: 24px;
  position: absolute;
  bottom: 8px;
  right: 10px;
  border-radius: 3px;
  padding: 2px;
  border: 1px solid #cdb09a;
`

export const TitleBulk = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold;
  font-family: Avenir;
  padding-bottom: 10px;
  border-bottom: 1px dashed lightgray;
  margin-bottom: 8px;
  text-transform: uppercase;
`

export const BulkShipTitleIcon = styled.img`
  max-width: 30px;
  margin-right: 16px;
`

export const EnabledLabel = styled.div`
  background: #72be8c;
  color: white;
  padding: 1px 12px;
  border-radius: 25px;
  font-weight: normal;
  font-size: 10px;
  margin-left: 12px;
`

export const ContentBulk = styled.div`
  font-size: 13px;
`

export const BulkAddressCardContainer = styled.div`
  max-width: 288px;
  margin: 0 auto;
  border-top: 1px dashed lightgrey;
  padding-top: 10px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/TeamStoreItem/styledComponents.tsx